document.addEventListener("DOMContentLoaded", function () {
  // Select all buttons with the class
  var buttons = document.querySelectorAll(".custom-button__kinetix");

  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var target = document.querySelector(".kaching-bundles");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });
});